import { Job } from "@/hooks/useJobQueries"

export const jobHasSegment = (job: Job, segmentId: string) => {
  return job.stages.some((stage) => stage.segments.some((segment) => segment.id === segmentId))
}
